import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-caption text-grey-8 q-mb-sm" }
const _hoisted_2 = {
  key: 0,
  class: "text-caption text-grey-7 q-mt-xs"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_time = _resolveComponent("q-time")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    "model-value": _ctx.modelValue,
    persistent: "",
    "onUpdate:modelValue": _cache[10] || (_cache[10] = (v) => _ctx.$emit('update:modelValue', v)),
    onShow: _ctx.onShow
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { style: {"width":"480px","max-width":"90vw"} }, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_toolbar_title, { class: "text-blue-brand text-bold" }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode("Edit Download Range", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_q_btn, {
                flat: "",
                round: "",
                dense: "",
                icon: "close",
                disable: _ctx.isSaving,
                onClick: _ctx.close
              }, null, 8, ["disable", "onClick"])
            ]),
            _: 1
          }),
          (_ctx.command)
            ? (_openBlock(), _createBlock(_component_q_card_section, {
                key: 0,
                class: "q-pt-none"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, " AGM UID " + _toDisplayString(_ctx.command.uid) + " · " + _toDisplayString(_ctx.typeLabel) + " · CID " + _toDisplayString(_ctx.command.commandId), 1),
                  _createVNode(_component_q_input, {
                    modelValue: _ctx.startDate,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.startDate) = $event)),
                    dense: "",
                    filled: "",
                    label: "Start Date (UTC)",
                    class: "q-mb-sm",
                    "data-test": "queued-range-start"
                  }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        name: "event",
                        class: "cursor-pointer"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_popup_proxy, {
                            ref: "qStartDateProxy",
                            "transition-show": "scale",
                            "transition-hide": "scale"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_date, {
                                modelValue: _ctx.startDate,
                                "onUpdate:modelValue": [
                                  _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startDate) = $event)),
                                  _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideProxy('qStartDateProxy')))
                                ],
                                mask: "YYYY-MM-DD HH:mm:ss"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 512)
                        ]),
                        _: 1
                      })
                    ]),
                    append: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        name: "access_time",
                        class: "cursor-pointer"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_popup_proxy, {
                            ref: "qStartTimeProxy",
                            "transition-show": "scale",
                            "transition-hide": "scale"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_time, {
                                modelValue: _ctx.startDate,
                                "onUpdate:modelValue": [
                                  _cache[2] || (_cache[2] = ($event: any) => ((_ctx.startDate) = $event)),
                                  _cache[3] || (_cache[3] = ($event: any) => (_ctx.hideProxy('qStartTimeProxy')))
                                ],
                                mask: "YYYY-MM-DD HH:mm:ss",
                                format24h: "",
                                "with-seconds": ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 512)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_q_input, {
                    modelValue: _ctx.endDate,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.endDate) = $event)),
                    dense: "",
                    filled: "",
                    label: "End Date (UTC)",
                    "data-test": "queued-range-end"
                  }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        name: "event",
                        class: "cursor-pointer"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_popup_proxy, {
                            ref: "qEndDateProxy",
                            "transition-show": "scale",
                            "transition-hide": "scale"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_date, {
                                modelValue: _ctx.endDate,
                                "onUpdate:modelValue": [
                                  _cache[5] || (_cache[5] = ($event: any) => ((_ctx.endDate) = $event)),
                                  _cache[6] || (_cache[6] = ($event: any) => (_ctx.hideProxy('qEndDateProxy')))
                                ],
                                mask: "YYYY-MM-DD HH:mm:ss"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 512)
                        ]),
                        _: 1
                      })
                    ]),
                    append: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        name: "access_time",
                        class: "cursor-pointer"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_popup_proxy, {
                            ref: "qEndTimeProxy",
                            "transition-show": "scale",
                            "transition-hide": "scale"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_time, {
                                modelValue: _ctx.endDate,
                                "onUpdate:modelValue": [
                                  _cache[7] || (_cache[7] = ($event: any) => ((_ctx.endDate) = $event)),
                                  _cache[8] || (_cache[8] = ($event: any) => (_ctx.hideProxy('qEndTimeProxy')))
                                ],
                                mask: "YYYY-MM-DD HH:mm:ss",
                                format24h: "",
                                "with-seconds": ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 512)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_ctx.isRaw)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Raw downloads are limited to " + _toDisplayString(_ctx.rawCapLabel) + ". ", 1))
                    : _createCommentVNode("", true),
                  (_ctx.errorMessage)
                    ? (_openBlock(), _createBlock(_component_q_banner, {
                        key: 1,
                        dense: "",
                        rounded: "",
                        class: "bg-red-1 text-negative q-mt-sm",
                        "data-test": "queued-range-error"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_q_card_actions, { align: "right" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                flat: "",
                "no-caps": "",
                label: "Cancel",
                disable: _ctx.isSaving,
                onClick: _ctx.close
              }, null, 8, ["disable", "onClick"]),
              _createVNode(_component_q_btn, {
                class: "btn-brand",
                "no-caps": "",
                label: "Save",
                loading: _ctx.isSaving,
                disable: !_ctx.command,
                "data-test": "queued-range-save",
                onClick: _ctx.save
              }, null, 8, ["loading", "disable", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value", "onShow"]))
}